﻿import * as htmlImport from './html';
import * as generatorsImport from './generators';
import * as defImport from './def';
import * as eventsImport from './events';
import * as dateImport from './date';
import * as webImport from './web';
import * as enumsImport from './enums';
import * as validationImport from './validation';
import * as localizationImport from './localization';
import * as blobImport from './blob';
import * as imgImport from './img';
import * as textImport from './text';
import * as cryptImport from './crypt';
import * as filesImport from './files';
import * as arrayImport from './array';

export type { ImageOutputMimeType, ImageResizeOptions } from './img';

export const html = htmlImport;
export const generators = generatorsImport;
export const web = webImport;
export const def = defImport;
export const files = filesImport;
export const events = eventsImport;
export const date = dateImport;
export const blob = blobImport;
export const img = imgImport;
export const enums = enumsImport;
export const text = textImport;
export const crypt = cryptImport;
export const array = arrayImport;
export const validation = validationImport;
export const localization = localizationImport;
